import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthActions } from '../../../../core/auth/state/auth.actions';
import { AuthState } from '../../../../core/auth/state/auth.state';

@Injectable({ providedIn: 'root' })
export class ChatbotDownloadService {
  constructor(private readonly store: Store) {}

  async download(url: string, filename: string): Promise<void> {
    const safeUrl = this.normalizeDownloadUrl(url);

    if (!this.store.selectSnapshot(AuthState.isTokenValid)) {
      await this.store.dispatch(new AuthActions.EnsureToken()).toPromise();
    }

    const authHeader = this.store.selectSnapshot(AuthState.header);
    if (!authHeader) throw new Error('Missing auth header');

    const res = await fetch(safeUrl, {
      method: 'GET',
      headers: {
        Authorization: authHeader,
        Accept: '*/*'
      }
    });

    if (!res.ok) {
      const err = await res.text().catch(() => '');
      throw new Error(`Download failed (${res.status}): ${err.slice(0, 200)}`);
    }

    const signedUrl = (await res.text()).replace(/^"|"$/g, '').trim();

    if (!signedUrl.startsWith('http')) {
      throw new Error(`Download response missing url: ${signedUrl.slice(0, 50)}`);
    }

    this.triggerBrowserDownload(signedUrl, filename);
  }

  private triggerBrowserDownload(signedUrl: string, filename: string) {
    const a = document.createElement('a');
    a.href = signedUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.download = filename || 'download';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  private normalizeDownloadUrl(rawUrl: string): string {
    let u = (rawUrl || '').trim();
    for (let i = 0; i < 3; i++) {
      const decoded = this.tryDecodeURIComponent(u);
      if (decoded === u) break;
      u = decoded;
    }
    return encodeURI(u);
  }

  private tryDecodeURIComponent(s: string): string {
    try {
      return decodeURIComponent(s);
    } catch {
      return s;
    }
  }
}
